import type { ChatMessage } from '@/Public/ChatBot/Types';

export function shouldShowDateSeparator(
    current: ChatMessage,
    previous: ChatMessage | undefined,
): boolean {
    if (!previous) return true;
    return current.timestamp.toDateString() !== previous.timestamp.toDateString();
}

export function formatDateSeparator(date: Date): string {
    return date.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' });
}
